import useInView from '../hooks/useInView';
import { useLanguage } from '../context/LanguageContext';

const LOGO = 'https://customer-assets.emergentagent.com/job_04606eda-c805-4e3a-af14-63242db4ed24/artifacts/q6gaf0lc_endless%20knot%20symbol%207.png';

const Symbol = () => {
  const [ref, inView] = useInView(0.15);
  const { t } = useLanguage();

  return (
    <section
      data-testid="symbol-section"
      className="bg-obsidian py-24 md:py-32"
      ref={ref}
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
        <div className={`reveal ${inView ? 'visible' : ''} w-24 h-24 md:w-32 md:h-32 mx-auto mb-10`}>
          <img
            src={LOGO}
            alt="The Endless Knot — Geranium Bohemicum emblem"
            className="w-full h-full object-contain"
            loading="lazy"
          />
        </div>

        <div className={`reveal reveal-delay-1 ${inView ? 'visible' : ''}`}>
          <span className="font-body text-xs tracking-[0.3em] uppercase" style={{ color: '#C5A065' }}>
            {t.symbol.label}
          </span>
          <div className="mt-4 mb-8 mx-auto w-9 h-px" style={{ backgroundColor: '#C5A065' }} />
        </div>

        <h2
          className={`reveal reveal-delay-2 font-heading font-light text-white leading-tight mb-8 ${inView ? 'visible' : ''}`}
          style={{ fontSize: 'clamp(1.9rem, 3.5vw, 3rem)' }}
        >
          {t.symbol.heading}
        </h2>

        <p className={`reveal reveal-delay-3 font-body text-white/60 text-base leading-relaxed mb-6 max-w-2xl mx-auto ${inView ? 'visible' : ''}`}>
          {t.symbol.para1}
        </p>

        <p className={`reveal reveal-delay-4 font-body text-white/60 text-base leading-relaxed max-w-2xl mx-auto ${inView ? 'visible' : ''}`}>
          {t.symbol.para2}
        </p>

        <div
          className={`reveal reveal-delay-4 mt-14 pt-10 border-t max-w-2xl mx-auto ${inView ? 'visible' : ''}`}
          style={{ borderColor: 'rgba(197, 160, 101, 0.2)' }}
        >
          <p className="font-body text-xs tracking-[0.25em] uppercase mb-4" style={{ color: '#C5A065' }}>
            {t.symbol.plantLabel}
          </p>
          <p className="font-body text-white/50 text-sm leading-relaxed">
            {t.symbol.plantNote}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Symbol;
